module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('game-summary', {
    attrs: {
      "gameId": this.gameId,
      "period": 0,
      "gameInfo": this.gameInfo
    }
  }), _vm._v(" "), _c('gamesheet', {
    attrs: {
      "gameId": this.gameId,
      "period": 0
    }
  }), _vm._v(" "), _c('faceoffs', {
    attrs: {
      "gameId": this.gameId,
      "period": 0
    }
  }), _vm._v(" "), _c('shots', {
    attrs: {
      "gameId": this.gameId,
      "period": 0,
      "gameInfo": this.gameInfo
    }
  }), _vm._v(" "), _c('turnovers', {
    attrs: {
      "gameId": this.gameId,
      "period": 0
    }
  }), _vm._v(" "), _c('hits', {
    attrs: {
      "gameId": this.gameId,
      "period": 0
    }
  }), _vm._v(" "), _c('zone-entries', {
    attrs: {
      "period": 0
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10d8a774"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/match-stats-22.vue
// module id = 585
// module chunks = 30